$(document).ready(function() {

    if (!document.querySelector('body.start') && !document.querySelector('body.landingpage')) {
        return;
    }

    // Register ScrollTrigger plugin
    gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

     // Header element
     const header = document.querySelector('#header-mobile');
     gsap.set(header, {
        zIndex: '22',
        autoAlpha: 1
     });

     // Start animation svg mask element
    const startAnimationSvgMask = document.querySelectorAll('.header_start_animation-mask img');
    const startAnimationSvgMaskContainer = document.querySelector('.header_start_animation-mask');
    const maskTL = gsap.timeline();

    // Video elements
    const videoContainer = document.querySelectorAll('.header_start_animation .start-animation-video');
    const videos = document.querySelectorAll('.header_start_animation .start-animation-video video');
    const videoImages = document.querySelectorAll('.header_start_animation .start-animation-video img');
    const videoTL = gsap.timeline();

    // Content element
    const content = document.querySelector('#content');

    // Sticky element
    const sticky = document.querySelector('.content-type-mask_strer_element_sticky');

    gsap.set(content, {
        marginTop: '0vh'
    });

    gsap.set(startAnimationSvgMaskContainer, {
        opacity: 1,
        visibility: 'visible'
    });

    if (sticky) {
        gsap.set(sticky, {
            opacity: 1,
            visibility: 'visible'
        });
    }

    // Play all videos
    if (videos) {
        videos.forEach(video => {
            video.play().catch(error => {
                console.error('Video play error:', error);
            });
        });
    }

    let scaleValue = 20;
    let leftValue = "-100%";
    let topValue = "-100%";
    let endValue = "+=250vh";

    if (window.innerWidth >= 1024) {
        scaleValue = 18;
        leftValue = "-100%";
        topValue = "-100%";
        endValue = "+=1100vh";
    }

    // Animate all video containers and their contents
    if (videoContainer.length > 0) {
        videoTL
            .to([...videoContainer, ...videos, ...videoImages], {
                backgroundColor: 'transparent',
                autoAlpha: 1,
                duration: 4,
                ease: "power4.out",
                delay: 1.5
            });
    }
    
    maskTL
        .to(startAnimationSvgMask, {
            scrollTrigger: {
                trigger: '.header_start_animation',
                start: "top top",
                end: endValue,
                scrub: 1.5,
                pin: true,
                //markers: true,
                onEnter: () => {
                    if (window.innerWidth > 1024) {
                        $('body').removeClass('mobile-nav-open');
                        $('.mobile-nav-wrapper').removeClass('open');
                    }
                    /*
                    if (video) {
                        video.play().catch(error => {
                            console.error('Video play error:', error);
                        });
                    }
                    */
                },
                onUpdate: (self) => {
                    const progress = self.progress;
                    const direction = self.direction;

                    let duration = direction === -1 ? 0.8 : 0.8;
                    let ease = direction === -1 ? "power4.out" : "power4.out";

                    gsap.to(startAnimationSvgMaskContainer, {
                        autoAlpha: progress > 0.95 ? 0 : 1,
                        duration: duration,
                        overwrite: true,
                        ease: ease
                    });

                    if (sticky) {
                        gsap.to(sticky, {
                            autoAlpha: progress < 0.1 ? 1 : 0,
                            duration,
                            overwrite: true,
                            ease
                        });
                    }

                    gsap.to('.start-animation .inner-cont', {
                        position: progress > 0.95 ? 'relative' : 'fixed',
                        duration: duration,
                        overwrite: true,
                        ease: ease
                    });

                    if (direction === -1 && progress === 0) {
                        gsap.to(['.logo-extend', '.logo-main'], {
                            autoAlpha: 1,
                            ease: "power4.out",
                            display: 'flex',
                            delay: 0.5
                        });
                    } else if (direction === 1 || progress >= 0.5) {
                        gsap.to(['.logo-extend', '.logo-main'], {
                            duration: 0.3,
                            ease: "power2.in",
                            autoAlpha: 0
                        });
                    }
                },
                onLeave: () => {
                    gsap.set(".content-main", { clearProps: "all" });
                },
                onLeaveBack: () => {
                    if (window.innerWidth > 1024 && !$('body').hasClass('landingpage')) {
                        $('body').addClass('mobile-nav-open');
                        $('.mobile-nav-wrapper').addClass('open');
                    }
                }
            },
            scale: scaleValue,
            left: leftValue,
            top: topValue,
            ease: "power1.out",
            duration: 2
        })
        .fromTo('.start-animation .inner-cont',
            { position: 'fixed' },
            { position: 'relative', scrollTrigger: { scrub: true } }
        );

});